/**
 * Rhythmz — Demo tracks manifest
 * ──────────────────────────────
 * Royalty-free / CC0 demo tracks so first-run visitors get instant visuals
 * without their own audio. Served from /public/demos/.
 *
 * Replace these with your own CC0 assets (e.g. from freepd.com, incompetech,
 * pixabay music). Keep filenames matched here and in /public/demos/.
 */

export interface DemoTrack {
  id: string;
  title: string;
  artist: string;
  url: string;
}

export const DEMO_TRACKS: DemoTrack[] = [
  { id: 'pulse', title: 'Neon Pulse', artist: 'Rhythmz Demo', url: '/demos/pulse.mp3' },
  { id: 'drift', title: 'Deep Drift', artist: 'Rhythmz Demo', url: '/demos/drift.mp3' },
  { id: 'rush', title: 'Acid Rush', artist: 'Rhythmz Demo', url: '/demos/rush.mp3' },
];
